export default "\r\n<app-size-detector></app-size-detector>\r\n<app-loading-screen></app-loading-screen>\r\n<router-outlet></router-outlet>\r\n"